import React, { useEffect } from 'react'
import Sidebar from './Sidebar'
import { useNavigate } from 'react-router-dom';

function AdminDashboard() {
  let navigate = useNavigate();
  
  const admin = sessionStorage.getItem('admin');

  useEffect(()=>{
    
    if(!admin)
      { 
        navigate('/login');
      }
  },[])
  

  return (
    <div>
      <Sidebar/>
    </div>
  )
}

export default AdminDashboard
